import { BookingWizardTab } from '../../BookingWizard';
import { TabNamesAfterReservation } from '../../BookingWizardConstants';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';

export const getDisableLinkForMultiFreight = (wizardData: BookingWizardData) => {
	const isLinkDisabled = (currentTab: BookingWizardTab) => {
		if (wizardData.innerWizardData.type !== 'freight') {
			return false;
		}

		const match = TabNamesAfterReservation.find(tabName => tabName === currentTab.name);
		if (!match) {
			return false;
		}

		const isMultiFreight = wizardData.innerWizardData.items.length > 0;
		return isMultiFreight;
	};

	return isLinkDisabled;
};
